/* @flow */
import * as React from 'react';
import RequireUser from 'lib/RequireUser';
import RequireSetup from 'lib/RequireSetup';
import RequireDesktop from 'lib/RequireDesktop';
import chainOnEnter from 'components/lib/chainOnEnter';
import { withRouter } from 'app/context/Router';
import SettingsView from 'settings/components/SettingsView';

let previousLocation;

const getPreviousLocation = () => {
  previousLocation = window.prevLocation;
};

class SettingsViewRouteHandler extends React.Component<$FlowFixMeProps> {
  static onEnter = chainOnEnter([RequireDesktop, RequireUser, RequireSetup, getPreviousLocation]);

  goBack = () => {
    if (previousLocation) {
      this.props.router.push(previousLocation);
    } else {
      this.props.router.push('/classes');
    }
  };

  render() {
    return <SettingsView goBack={this.goBack}>{this.props.children}</SettingsView>;
  }
}

export { SettingsViewRouteHandler };
export default withRouter(SettingsViewRouteHandler);
